import { FilterField } from "layout/TableConstructor/types";
import { CompetenceScore, ExaminationCompetencyListQuery, TrialListQueryVariables } from "@generated/graphql";
import { InputType } from "components/generators/inputsGenerator";
import {
  aiGenerationPercentageFilter,
  candidateFullNameFilter,
  candidateNumericIdFilter,
  candidateScoreFilter,
  completedAtFilter,
  getStatusFilter,
} from "components/ExaminationList/config/filterConfig";

export type TrialFilter = NonNullable<TrialListQueryVariables["filter"]>;
export type CompetencyList = NonNullable<ExaminationCompetencyListQuery["examination"]["competencyMap"]>["competences"];
const filterConfig = (competencyList: CompetencyList): FilterField<TrialFilter>[] => {
  const dynamicFilters =
    competencyList?.map<FilterField<TrialFilter>>((c) => {
      return {
        label: `Компетенция ${c.title}`,
        name: `competenceScores.${c.id}`,
        type: InputType.TEXT,
        inputType: "number",
      };
    }) || [];
  return [
    candidateNumericIdFilter,
    candidateFullNameFilter,
    completedAtFilter,
    getStatusFilter({ name: "status" }),
    candidateScoreFilter,
    aiGenerationPercentageFilter,
    {
      label: "динамические компетенции",
      name: "competenceScores",
      type: InputType.TEXT,
      isHidden: true,
      customFilter: (value): CompetenceScore[] | undefined => {
        if (typeof value === "object") {
          return Object.entries(value).reduce<CompetenceScore[]>((acc, [k, v]) => {
            const isValueExist = typeof v !== "undefined" && !Number.isNaN(v) && v !== "";
            if (isValueExist) {
              acc.push({
                competenceId: k,
                score: +v,
              });
            }
            return acc;
          }, []);
        }
        return undefined;
      },
    },
    ...dynamicFilters,
  ];
};

export default filterConfig;
